import { render } from "./Branshes.vue?vue&type=template&id=26d923a9&scoped=true"
import script from "./Branshes.vue?vue&type=script&lang=js"
export * from "./Branshes.vue?vue&type=script&lang=js"

import "./Branshes.vue?vue&type=style&index=0&id=26d923a9&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26d923a9"

export default script